import { render, staticRenderFns } from "./OwnTheLook.vue?vue&type=template&id=61beac4e"
import script from "./OwnTheLook.vue?vue&type=script&lang=js"
export * from "./OwnTheLook.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports